import Cookie from 'js-cookie'
import createPersistedState from 'vuex-persistedstate'

const sessionLengthHours = 1

const namespaced = true
const namespace = 'Marketing/CartRules'

import { default as session, namespace as sessionNamespace } from './modules/session'
import { default as log, namespace as logNamespace } from './modules/log'

const modules = {
    [sessionNamespace]: session,
    [logNamespace]: log,
}

const plugins = [
    createPersistedState({
        paths: [`${namespace}.${sessionNamespace}`],
        key: `${namespace}/${sessionNamespace}`,
        storage: {
            getItem: (key) => Cookie.get(key),
            setItem: (key, value) => Cookie.set(key, value, { expires: sessionLengthHours / 24 }),
            removeItem: key => Cookie.remove(key),
        },
    }),
    createPersistedState({
        paths: [`${namespace}.${logNamespace}`],
        key: `${namespace}/${logNamespace}`,
    }),
]

export { namespaced, namespace, modules, plugins }
